<template>
  <div>
    <div class="header-search">
      <div class="form-input">
        <mc-input
          :placeholder="userLogged ? $t('searchbar.loggedInTitle') : $t('searchbar.loggedOutTitle')"
          :value="searchId"
          hiddenlabel
          width="auto"
          class="form-input__field"
          @input="updateSearchId"
          @keyup.enter="processSearchId"
        />
      </div>

      <mc-button
        class="search-button"
        :class="{ 'button--loading': isLoading }"
        data-test="page-header-track-button"
        @click="processSearchId"
      >
        <mc-loading-indicator v-if="showSpinner" label="" />
        <span v-else> {{ $t("searchbar.track") }} </span>
      </mc-button>
    </div>
    <div v-if="noInputSubmitted && !searchId" class="font--small color-error">{{ $t("searchbar.error.input") }}</div>
    <mc-modal :open="showModal" size="medium" :heading="$t('searchbar.title')" @close="showModal = false">
      <div v-if="!showSpinner" class="mt-3 mb-3">
        <span v-if="!showErrorMessage"
          ><strong>'{{ searchId }}' </strong>{{ $t("searchbar.heading") }}</span
        >
        <div v-if="showErrorMessage" data-test="page-header-track-error">
          {{ $t("searchbar.error.noresult") }} {{ searchId }}
        </div>
      </div>

      <mc-loading-indicator v-if="showSpinner" class="card card--loading" />

      <MultipleResultsTable
        v-if="!showSpinner"
        :shipments="billOfLadingData"
        :bookByReference="searchId"
        data-test="modal-search-results"
        @close-modal="showModal = false"
      />
      <mc-button slot="secondaryAction" appearance="neutral" :label="$t('common.cancel')" @click="showModal = false" />
    </mc-modal>
  </div>
</template>
<script>
import MultipleResultsTable from "@/components/search/MultipleResultsTable.vue";
import CONSTANTS from "@/lib/CONSTANTS";
import { getShipments } from "@/lib/api";
import { parseResponseAsShipments } from "@/lib/parseResponseAsShipments";
import { isUserLogged } from "@/lib/utilities";

export default {
  name: "SearchBar",
  components: {
    MultipleResultsTable
  },
  data() {
    return {
      searchId: null,
      hideSearchBar: true,
      showModal: false,
      billOfLadingData: [],
      showSpinner: false,
      showErrorMessage: false,
      userLogged: isUserLogged(),
      isLoading: false,
      noInputSubmitted: false,
      shipmentId: null
    };
  },
  watch: {
    showModal(showModal) {
      // Clear the fetched shipping data if the user closes the modal.
      if (!showModal) {
        this.billOfLadingData.length = 0;
      }
    }
  },
  methods: {
    updateSearchId($event) {
      this.searchId = $event.target.value;
      this.noInputSubmitted = false;
      this.showSpinner = false;
    },
    async processSearchId() {
      this.showSpinner = true;
      if (this.searchId) {
        if (
          CONSTANTS.TPDOC_NUMBER_REGEX.test(this.searchId.toLowerCase()) ||
          CONSTANTS.CONTAINER_ID_REGEX.test(this.searchId.toLowerCase())
        ) {
          window.location.href = `/shipment-details/search/${this.searchId}`;
        } else {
          await this.makeApiRequest(this.searchId);
        }
        this.$sendGAEvent({
          event: "DQCS",
          action: "Click",
          category: "SO_OutboundLink",
          label: { data: "SOSearchTriggered", isExport: !!this.$route?.path?.toLowerCase()?.includes?.("export") }
        });
      } else {
        this.noInputSubmitted = true;
      }
    },

    async makeApiRequest(bookedByReference) {
      this.showSpinner = true;

      try {
        const response = await getShipments({ bookedByReference });
        if (response.data.length === 1) {
          window.location.href = `/shipment-details/${response.data[0].id}`;
        } else {
          this.isLoading = false;
          this.showModal = true;
          this.billOfLadingData.push(...parseResponseAsShipments(response.data));
          this.showSpinner = false;
          this.showErrorMessage = false;
        }
      } catch (e) {
        window.location.href = `/shipment-details/search/${bookedByReference}`;
      }

      return this.billOfLadingData;
    }
  }
};
</script>
